module.exports = __webpack_public_path__ + "static/media/man7c.b6bf790a.png";